// export type {}
import { useQuery } from '@tanstack/react-query';
import { AboutService } from '../services/AboutServices';

export type { AboutType } from '@xanectech/types';

export const useAbout = () => {
  return useQuery({
    queryKey: ['about'],
    queryFn: () => AboutService.getAllAbout(),
  });
};

export const useAboutByAppName = (appName: string) => {
  return useQuery({
    queryKey: ['about_by_app_name', appName],
    queryFn: () => AboutService.getAboutByAppName(appName),
    enabled: !!appName,
  });
};
